import { DatePipe } from '@angular/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Validators } from '@angular/forms';
import { AdsPlacement } from 'src/app/classes/ads-placement';
import { Organization } from 'src/app/classes/organization';
import { Shift } from 'src/app/classes/shift';
import { FormGroup } from '@angular/forms';
import AdsPlacementStatuses from 'src/app/constants/ads-placement-statuses';
import { AdsPlacementService } from 'src/app/classes/ads-placement.service';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AdsCampaignService } from 'src/app/services/ads-campaign.service';
import { Assignment } from 'src/app/classes/assignment';
import * as fa from '@fortawesome/free-solid-svg-icons';
import { Product } from 'src/app/classes/product';
import { PictureComponent } from './picture/picture.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.css'],
  providers: [DatePipe],
})

export class EditComponent implements OnInit, OnDestroy {
  adsPlacement: AdsPlacement = new AdsPlacement()
  organizations: Organization[] = [];
  assignments: Assignment[] = [];
  
  fa = fa

  groupByOptions = { 
    'asset': $localize`Asset`,
    'country': $localize`Country`,
    'city': $localize`City`,
  }
  adsPlacementStatuses = AdsPlacementStatuses;

  activeTab: string = 'basics';

  examples: Shift[] = [];

  loaded = false

  disableEdit = false;
  editPrompt = '';

  updateSub: Subscription

  statistics: any[] = [];
  statisticsData: any[] = [];

  form = new FormGroup({
    name: new FormControl('', [Validators.required]),
    organization_id: new FormControl(null, [Validators.required]),
    assignment_id: new FormControl(null, [Validators.required]),
    notes: new FormControl(''),
    status: new FormControl('inactive', [Validators.required]),
    start_date: new FormControl(''),
    end_date: new FormControl(''),
  });

  statisticsForm = new FormGroup({
    start_date: new FormControl(''),
    end_date: new FormControl(''),
    group_by: new FormControl(null),
  });

  constructor(
    private adsCampaignService: AdsCampaignService,
    private adsPlacementService: AdsPlacementService,
    private datePipe: DatePipe,
    private titleService: Title,
    private router: Router,
    private route: ActivatedRoute,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.statisticsForm.patchValue({
      start_date: this.datePipe.transform(
        new Date().setDate(new Date().getDate() - 14),
        'yyyy-MM-dd'
      ),
      end_date: this.datePipe.transform(new Date(), 'yyyy-MM-dd'),
    });

    this.adsCampaignService.organizations().subscribe(organizations => {
      this.organizations = organizations;

      this.route.params.subscribe(params => {
        if (params['placementId'] != 'create') {
          const placementId = params['placementId']

          this.adsPlacementService.get(placementId).subscribe(adsPlacement => {
            this.adsPlacement = adsPlacement;
            this.form.patchValue(adsPlacement);

            this.titleService.setTitle(this.adsPlacement.name)
            this.loaded = true;

            this.adsPlacementService.assignments(this.adsPlacement.organization_id).subscribe(assignments => {
              this.assignments = assignments;
            });

            this.route.fragment.subscribe(fragment => {
              this.activeTab = fragment ? fragment : 'basics';
        
              if(this.activeTab == 'statistics') {
                this.getStatistics();
              }
            });
          });

          this.adsPlacementService.initSocket()

          this.updateSub =  this.adsPlacementService.listen().subscribe((update) => {
            console.log(update)
            
            if(update.type == 'assignment' && update.ads_placement_id == placementId) {
              this.adsPlacementService.get(placementId).subscribe(adsPlacement => {
                this.adsPlacement.assignment.picture = adsPlacement.assignment.picture;
                this.adsPlacement.assignment.updating = false
              })
                
            }
      
            if(update.type == 'product' && update.ads_placement_id == placementId) { 
              const product = this.adsPlacement.assignment.products.find(p => p.product.id == update.product_id)
              
              this.adsPlacementService.productPicture(this.adsPlacement.id, product.product.id).subscribe((picture) => {
                if(product) {
                  product.product.picture = picture.url;
                  product.product.updating = false
                }
              })
            }
          })
        }

        else {
          this.titleService.setTitle($localize`Campaign`);
          this.adsPlacement = new AdsPlacement();
          this.form.reset();
          this.form.controls.status.setValue('inactive');
          this.assignments = [];

          this.form.controls.organization_id.valueChanges.subscribe(organizationId => {
            this.form.controls.assignment_id.setValue(null);
            
            if(organizationId) {
              this.adsPlacementService.assignments(organizationId).subscribe(assignments => {
                this.assignments = assignments;
              });
            }

            else {
              this.assignments = [];
            }
          });
        }
      });
    });
  }

  getStatistics(): void {
    this.adsPlacementService.statistics(this.adsPlacement.id, this.statisticsForm.value).subscribe(statistics => {
      this.statisticsData = statistics;
      this.statistics = this.groupStatistics(statistics);
    })
  }

  groupStatistics(statistics: any[]): any[] {
    const groupBy = this.statisticsForm.value.group_by as string | null;
    if (!groupBy || !statistics?.length) {
      return statistics;
    }

    const buckets = new Map<string, { first: any; count: number }>();

    for (const row of statistics) {
      let key: string;
      switch (groupBy) {
        case 'asset':
          key = row.product?.id != null ? `id:${row.product.id}` : 'main';
          break;
        case 'city':
          key = `${String(row.country ?? '')}\u0000${String(row.city ?? '')}`;
          break;
        default:
          key = String(row[groupBy] ?? '');
      }

      const existing = buckets.get(key);
      if (existing) {
        existing.count += 1;
      } else {
        buckets.set(key, { first: row, count: 1 });
      }
    }

    const rows = Array.from(buckets.values()).map(({ first, count }) => {
      const views = count;
      if (groupBy === 'asset') {
        return { ...first, country: '', city: '', views };
      }
      if (groupBy === 'country') {
        return { country: first.country ?? '', city: '', views };
      }
      if (groupBy === 'city') {
        return { country: first.country ?? '', city: first.city ?? '', views };
      }
      return { ...first, views };
    });

    rows.sort((a, b) => (b.views ?? 0) - (a.views ?? 0));
    return rows;
  }

  ngOnDestroy(): void {
    this.updateSub.unsubscribe();
  }

  save(): void {
    if (this.form.valid) {
      this.adsPlacementService.save(this.adsPlacement.id, this.form.value as AdsPlacement).subscribe(() => {
        this.router.navigate(['/placements']);
      });
    }
  }

  delete(): void {
    if (confirm($localize`Are you sure?`)) {
      this.adsPlacementService.delete(this.adsPlacement.id).subscribe(() => {
        this.router.navigate(['/placements']);
      });
    }
  }

  setFragment(activeTab: string) {
    this.router.navigate([], { fragment: activeTab }).then(() => { })
  }

  edit(): void {
    if(this.disableEdit || !this.editPrompt.trim()) return;

    this.disableEdit = true

    this.adsPlacementService.edit(this.adsPlacement.id, this.editPrompt).subscribe((productIds) => {
      this.editPrompt = '';
      this.disableEdit = false;
      
      this.picturesUpdating(true, productIds);
    });
  }

  discard(): void {
    if(confirm($localize`Are you sure?`)) {
      this.picturesUpdating(true);

      this.adsPlacementService.discard(this.adsPlacement.id).subscribe(() => {
        this.picturesUpdating(false);
      });
    }
  }

  picturesUpdating(updating: boolean, productIds?: number[]): void {
    this.adsPlacement.assignment.updating = updating;
    this.adsPlacement.assignment.products.forEach(product => {
      if(!productIds || productIds.includes(product.product.id)) {
        product.product.updating = updating;
      }
    });
  }

  pictureViewer(product?: Product, index?: number): void {
    const modal = this.modalService.open(PictureComponent, { size: 'lg', centered: true })

    modal.componentInstance.adsPlacement = this.adsPlacement;
    modal.componentInstance.product = product
    modal.componentInstance.index = index
  }
}
